import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { customerApi, formatApiError } from "@/lib/api";
import { useCustomerAuth } from "@/context/CustomerAuthContext";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import { Button } from "@/components/ui/button";
import { CheckCircle2, XCircle, Loader2 } from "lucide-react";

export default function VerifyEmailPage() {
  const { token } = useParams();
  const navigate = useNavigate();
  const { refresh } = useCustomerAuth();
  const [state, setState] = useState("verifying"); // verifying | ok | error
  const [msg, setMsg] = useState("");

  useEffect(() => {
    customerApi.post("/customer/verify-email", { token })
      .then(() => { setState("ok"); refresh(); })
      .catch((e) => { setState("error"); setMsg(formatApiError(e.response?.data?.detail)); });
  }, [token, refresh]);

  return (
    <div className="min-h-screen bg-background flex flex-col">
      <Header />
      <main className="flex-1 w-full max-w-md mx-auto px-4 py-20 text-center" data-testid="verify-page">
        {state === "verifying" && <><Loader2 className="mx-auto animate-spin text-accent" size={40} /><p className="mt-4 text-muted-foreground">Verifying your email…</p></>}
        {state === "ok" && (
          <>
            <CheckCircle2 className="mx-auto text-emerald-600" size={48} />
            <h1 className="mt-4 text-2xl font-extrabold">Email verified</h1>
            <p className="mt-2 text-muted-foreground">Your email address is confirmed. Thanks!</p>
            <Button className="mt-6 bg-steel text-white" data-testid="verify-goto-account" onClick={() => navigate("/account")}>Go to my account</Button>
          </>
        )}
        {state === "error" && (
          <>
            <XCircle className="mx-auto text-red-500" size={48} />
            <h1 className="mt-4 text-2xl font-extrabold">Verification failed</h1>
            <p className="mt-2 text-muted-foreground">{msg || "This link is invalid or has expired."}</p>
            <Button className="mt-6 bg-steel text-white" onClick={() => navigate("/account")}>Go to my account</Button>
          </>
        )}
      </main>
      <Footer />
    </div>
  );
}
